import { Participante } from '@/components/participantes/participante.model';
import { RolAutoridad } from '@/shared/model/enumerations/rol-autoridad.model';
import { Persona } from '@/shared/model/persona/persona.model';

export interface IMenuInstitucionClaustroSnp {
  value?: InstitucionClaustroSnp;
  text?: string;
}

export class MenuInstitucionClaustroSnp implements IMenuInstitucionClaustroSnp {
  constructor(public value?: InstitucionClaustroSnp, public text?: string) {}
}

export interface IMenuSedeClaustroSnp {
  value?: SedeClaustroSnp;
  text?: string;
}

export class MenuSedeClaustroSnp implements IMenuSedeClaustroSnp {
  constructor(public value?: SedeClaustroSnp, public text?: string) {}
}
export interface IMenuTiempoDedicacionClaustroSnp {
  value?: TiempoDedicacionClaustroSnp;
  text?: string;
}

export class MenuTiempoDedicacionClaustro implements IMenuTiempoDedicacionClaustroSnp {
  constructor(public value?: TiempoDedicacionClaustroSnp, public text?: string) {}
}

export interface ITiempoDedicacionClaustroSnp {
  id?: number;
  nombre?: string;
}

export class TiempoDedicacionClaustroSnp implements ITiempoDedicacionClaustroSnp {
  constructor(public id?: number, public nombre?: string) {}
}

export interface ISedeClaustroSnp {
  claveSede?: string;
  claveDependencia?: string;
  nombreDependencia?: string;
  sede?: string;
}

export class SedeClaustroSnp implements ISedeClaustroSnp {
  constructor(public claveSede?: string, public claveDependencia?: string, public nombreDependencia?: string, public sede?: string) {}
}

export interface IInstitucionClaustroSnp {
  claveInstitucion?: string;
  nombreInstitucion?: string;
}

export class InstitucionClaustroSnp implements IInstitucionClaustroSnp {
  constructor(public claveInstitucion?: string, public nombreInstitucion?: string) {}
}

export interface ITipoFuncion {
  clave?: string;
  nombre?: string;
}

export class Funcion implements ITipoFuncion {
  constructor(public clave?: string, public nombre?: string) {}
}
export interface IMenuFuncion {
  value?: Funcion;
  text?: string;
}

export class MenuFuncion implements IMenuFuncion {
  constructor(public value?: Funcion, public text?: string) {}
  static fromObject(item: Funcion): MenuFuncion {
    return new MenuFuncion(item, item.nombre);
  }
}

export interface IProfesorSnp {
  tiempoDedicacion?: TiempoDedicacionClaustroSnp;
  institucion?: InstitucionClaustroSnp;
  sede?: SedeClaustroSnp;
  areaConocimientoId?: number;
  areaConocimientoNombre?: string;
  vigenciaEstatus?: string;
  nivelSniClave?: string;
  nivelSniNombre?: string;
  vigenciaTipo?: string;
  vigenciaFechaInicio?: Date;
  vigenciaFechaFin?: Date;
  claustroFechaIngreso?: string;
  claustroFechaBaja?: string;
  alumnos?: Alumno[];
  clavePrograma?: string;
}

export class ProfesorSnp implements IProfesorSnp {
  constructor(
    public tiempoDedicacion?: TiempoDedicacionClaustroSnp,
    public institucion?: InstitucionClaustroSnp,
    public sede?: SedeClaustroSnp,
    public areaConocimientoId?: number,
    public areaConocimientoNombre?: string,
    public vigenciaEstatus?: string,
    public nivelSniClave?: string,
    public nivelSniNombre?: string,
    public vigenciaTipo?: string,
    public vigenciaFechaInicio?: Date,
    public vigenciaFechaFin?: Date,
    public claustroFechaIngreso?: string,
    public claustroFechaBaja?: string,
    public alumnos?: Alumno[]
  ) {
    if (!alumnos) {
      this.alumnos = [];
    }
  }
}

export interface IParticipacionSnp {
  id?: string;
  solicitudId?: string;
  solucionId?: string;
  contenedorId?: string;
  dependenciaId?: string;
  participante?: Participante;
  rol?: RolAutoridad;
  profesorSnp?: ProfesorSnp;
}

export class ParticipacionSnp implements IParticipacionSnp {
  constructor(
    public id?: string,
    public solicitudId?: string,
    public solucionId?: string,
    public contenedorId?: string,
    public dependenciaId?: string,
    public participante?: Participante,
    public rol?: RolAutoridad,
    public profesorSnp?: ProfesorSnp
  ) {
    if (!profesorSnp) {
      this.profesorSnp = new ProfesorSnp();
    }
    if (!participante) {
      this.participante = new Participante();
    }
  }

  static fromObject(item: IParticipacionSnp): ParticipacionSnp {
    const participante = new ParticipacionSnp();

    for (const [key, value] of Object.entries(item)) {
      participante[key] = value;
    }

    return participante;
  }
}

export interface Alumno {
  idParticipacion?: string;
  cvu?: string;
  nombre?: string;
  apellidoPaterno?: string;
  apellidoMaterno?: string;
  relacion?: { clave?: string; nombre?: string };
  asociado?: boolean;
  valido?: boolean;
  activo?: boolean;
}

export interface IProfesorAlumno {
  profesor?: ParticipacionSnp;
  alumno?: Alumno;
}

export class ProfesorAlumno implements IProfesorAlumno {
  constructor(public profesor?: ParticipacionSnp, public alumno?: Alumno) {}
}

export interface IProfesorAlumnoSnp {
  cvuProfesor?: string;
  cvuAlumno?: string;
  solicitudId?: string;
  claveRelacion?: string;
  nombreRelacion?: string;
}

export class ProfesorAlumnoSnp implements IProfesorAlumnoSnp {
  constructor(
    public cvuProfesor?: string,
    public cvuAlumno?: string,
    public solicitudId?: string,
    public claveRelacion?: string,
    public nombreRelacion?: string
  ) {}
}
